import { render, staticRenderFns } from "./ContainersList.vue?vue&type=template&id=6abb3f85"
import script from "./ContainersList.vue?vue&type=script&lang=js"
export * from "./ContainersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports